import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { CatalogoTiposParticipacionDTO } from 'src/app/core/models/persona/interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoTiposParticipacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoTiposParticipacionService(): Observable<BodyListResponse<CatalogoTiposParticipacionDTO>> {
    return this.http.get<BodyListResponse<CatalogoTiposParticipacionDTO>>(API_URL + '/api/v1/catalogoTiposParticipacion/todos');
  }

  guardarCatalogoTiposParticipacionService(catalogoTiposParticipacionDTO: CatalogoTiposParticipacionDTO): Observable<BodyResponse<CatalogoTiposParticipacionDTO>> {
    return this.http.post<BodyResponse<CatalogoTiposParticipacionDTO>>(API_URL + '/api/v1/catalogoTiposParticipacion', catalogoTiposParticipacionDTO);
  }

  getCatalogoTiposParticipacionPorCodigoTipoParticipacionService(codigoTiposParticipacion: string): Observable<BodyResponse<CatalogoTiposParticipacionDTO>> {
    return this.http.get<BodyResponse<CatalogoTiposParticipacionDTO>>(API_URL + '/api/v1/catalogoTiposParticipacion/' + codigoTiposParticipacion);
  }
}
